import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  getRDCEffortsList,
  RDCEffortsListParams,
  getRDCEffortsExport,
} from '../../../services/recentTimeDrugCollectionEfforts'

// 列表
export const getRDCEffortsListAsync = createAsyncThunk<
  void,
  RDCEffortsListParams,
  RootThunkApi<void>
>('RDCEfforts/getRDCEffortsListAsync', async (params, api) => {
  return sendAsync(getRDCEffortsList(params), api)
})

// 导出
export const getRDCEffortsExportAsync = createAsyncThunk<
  void,
  RDCEffortsListParams,
  RootThunkApi<void>
>('RDCEfforts/getRDCEffortsExportAsync', async (params, api) => {
  return sendAsync(getRDCEffortsExport(params), api)
})
